import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {OrderService} from '../services/order.service';
import {MatSnackBar} from '@angular/material/snack-bar';


@Component({
  selector: 'app-ident',
  templateUrl: './ident.component.html',
  styleUrls: ['./ident.component.css']
})
export class IdentComponent implements OnInit {

  public protectedOrderId: string;

  constructor(
    private orderService: OrderService,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
  ) {
  }


  showMessage(message) {
    this.snackBar.open(message, null, {
      duration: 5000,
      panelClass: ['app-mat-snack-bar']
    });
  }

  isLoading = true;

  ngOnInit() {

    let lng = navigator.language || 'en';
    if (lng.substr(0, 2) == 'de') {
      lng = 'de';
    } else {
      lng = 'en';
    }

    const orderKey = this.route.snapshot.paramMap.get('orderKey');

    this.orderService.getIdentUrl(orderKey).subscribe((result) => {
      this.isLoading = false;
        window.location.href = result;
      },
      err => {
        this.showMessage(err.error.message || err.error || err.message);
      });

}

}
